import { tryProactiveRefresh } from "../services/auth-session";
import storage from "./storage";

/**
 * Extends the global `Window` interface to include the `grecaptcha` property.
 */
declare global {
  interface Window {
    grecaptcha: any;
  }
}

export const getToken = () => {};

/**
 * @param {string} SITE_KEY
 * @returns {string} token
 */
export const getCaptchaToken = async (SITE_KEY: string): Promise<any> => {
  let token = null;
  await window.grecaptcha
    ?.execute(SITE_KEY, { action: "submit" })
    .then((res: string) => {
      token = res;
    });
  return token;
};

/**
 * Scheduled proactive refresh (guarded — stops after 401).
 */
export const refreshTokenAPI = async (): Promise<boolean> => {
  if (!storage.getRefreshToken() || !storage.getToken()) {
    return false;
  }
  return tryProactiveRefresh();
};

// Getting Formik Schema Required Validation
export const isFieldRequired = (schema: any, controlId: string): boolean => {
  const fieldDescription = schema?.describe()?.fields?.[controlId];
  if (!fieldDescription) return false;

  if (fieldDescription.tests?.some((t: any) => t.name === "required")) {
    return true;
  }

  if (
    fieldDescription.type === "number" &&
    fieldDescription.optional === false
  ) {
    return true;
  }

  return false;
};
